import {monitor} from '@soluto-private/mx-monitor';
import {
    basePlanDetailsValidator,
    userValidator,
    Partner,
    unverifiedPlansValidator,
    verifiedPlansValidator,
    terminatedPlansValidator,
    filteredPartnersValidator,
} from '@soluto-private/mx-context-types';
import {ContextKey, Key} from '../storage';

const validators: Record<Key, (value: unknown) => boolean> = {
    [Key.Client]: partner => typeof partner === 'string' && Object.values<string>(Partner).includes(partner),
    [Key.Plans]: basePlanDetailsValidator,
    [Key.Services]: arr => Array.isArray(arr) && arr.every(v => typeof v === 'string'),
    [Key.Language]: value => typeof value === 'string',
    [Key.ProductType]: value => typeof value === 'string',
    [Key.User]: userValidator,
    [Key.UnverifiedPlans]: unverifiedPlansValidator,
    [Key.VerifiedPlans]: verifiedPlansValidator,
    [Key.TerminatedPlans]: terminatedPlansValidator,
    [Key.FilteredPartners]: filteredPartnersValidator,
};

export const validateValue = (key: ContextKey, value: unknown): boolean => {
    const validator = validators[key as Key];
    if (!validator || value == null) {
        return true;
    }

    let isValid: boolean = true;
    const res = validator(value);

    if (!res) {
        const error = new Error(`Unsupported value for key ${key}`);
        monitor.error(error.message, error, {key, invalidValue: value});
        isValid = false;
    }

    return isValid;
};
